import axios from 'axios'
import { useEffect, useState } from 'react'
import { BASE_URL, SUPER_ADMIN_TOKEN } from '../../constants'

export const useClientUsers = (clientID, query = '') => {
  const [users, setUsers] = useState([])
  useEffect(() => {
    axios.get(`${BASE_URL}/client/${clientID}/users${query}`).then((users) => {
      setUsers(users.data)
    })
  }, [clientID, query])
  return users
}

export const useClientList = (query = '') => {
  const [listData, setListData] = useState([])
  const clientID = JSON.parse(localStorage.getItem('userDetails')).user.clientID
  useEffect(() => {
    const fetchList = async () => {
      const res = await axios.get(
        `${BASE_URL}${`/client/${clientID}/users?${query}`}`
      )
      console.log('res', res.data)
      setListData(res.data)
    }
    fetchList()
    // console.log(users)
  }, [query])
  return listData
}
